export default "__VITE_ASSET__BGPGqj5p__"